import { METHOD_GET } from '@yme/utils/constants';
import { serviceAPI } from '../../../../utils/api';
export const getProductCarouselData = (url, callback) => serviceAPI({
    url,
    method: METHOD_GET,
}, {
    request: null,
    successCb: (resp) => callback(resp),
    failure: null,
    success: null,
});
